// extracted by mini-css-extract-plugin
export var equalColumn = "_gg-0";